export default "__VITE_ASSET__9171c7b6__"